import React from "react";
import JobList from "@presentation/components/job/JobList";
import { pageFillContentStyle, pageHeaderRegionStyle, pageHeaderStyle, pageShellStyle, pageTitleStyle } from "@presentation/common/pageLayout";

/**
The one Jobs page (`/jobs`) - every project, team, and global scope lives here, selected via the
`teamId`/`projectId`/`scope` query parameters (see `JobList`'s `scopeToSearchParamsInit`), not via
separate routes/pages per scope.
*/
const JobsPage: React.FC = () => {
  return (
    <div style={pageShellStyle}>
      <div style={pageHeaderRegionStyle}>
        <div style={pageHeaderStyle}>
          <h1 style={pageTitleStyle}>Jobs</h1>
        </div>
      </div>
      <div style={pageFillContentStyle}>
        <JobList />
      </div>
    </div>
  );
};

export default JobsPage;
